// @flow

import React from 'react';
import { Translate } from 'react-redux-i18n';

type Props = {
  oldValue?: string,
  newValue?: string,
  optionalValue?: string,
  label: string,
  labelVariables? : {[key: string] : string}
}

export default class KpiSelector extends React.PureComponent<Props> {
  static defaultProps = {
    labelVariables: {},
  };
  render() {
    const { oldValue, newValue, optionalValue, label } = this.props;
    return (
      <tr>
        <td><Translate value={label} {...this.props.labelVariables}/></td>
        <td>{oldValue}</td>
        <td>{newValue}</td>
        <td>{optionalValue}</td>
      </tr>
    );
  }
}
